import { render, staticRenderFns } from "./KYCForm.vue?vue&type=template&id=380c0053&scoped=true"
import script from "./KYCForm.vue?vue&type=script&lang=js"
export * from "./KYCForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c0053",
  null
  
)

export default component.exports